module.exports = __webpack_public_path__ + "static/media/bj.7e857cc.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/electricity/bj.wav
// module id = K2jm
// module chunks = 1